import React from 'react';
import { MdDescription } from 'react-icons/md';
import './LoadingState.css';

export default function LoadingState({ title = 'Carregando informações', description = 'Aguarde enquanto buscamos os dados.' }) {
  return <div className="app-loading-state hidethis" role="status" aria-live="polite" aria-busy="true">
    <div className="app-loading-state-icon" aria-hidden="true"><MdDescription /><span /></div>
    <strong className="app-loading-state-title">{title}</strong>
    <span className="app-loading-state-description">{description}</span>
    <div className="app-loading-state-preview" aria-hidden="true">{[0, 1, 2].map(row => <div key={row}><i /><i /><i /></div>)}</div>
  </div>;
}
